// extracted by mini-css-extract-plugin
export default {"container":"OfficeInfo_container__H4OU-","address":"OfficeInfo_address__ALS9q","hr":"OfficeInfo_hr__MdZOT"};